import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getParametroId } from 'services/servicioGet';
import { TipoParametro } from 'utils/models/types';

interface ParametrosState {
  parametroPorId: TipoParametro;
  loadingParametroPorId: boolean;
  errorParametroPorId: string | null;
}

// Estado inicial del slice
const initialState: ParametrosState = {
  parametroPorId: {
    Valor: 0,
    Id: 0,
    Nombre: '',
  },
  loadingParametroPorId: false,
  errorParametroPorId: null,
};

// Thunk para obtener los tipos de elenco
export const fetchParametroId = createAsyncThunk<TipoParametro, number, { rejectValue: string }>(
  'fetchParametroId',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getParametroId(id.toString());
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de parámetros
const parametroPorIdSlice = createSlice({
  name: 'parametroPorId',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchParametroId.pending, state => {
        state.loadingParametroPorId = true;
        state.errorParametroPorId = null;
      })
      .addCase(fetchParametroId.fulfilled, (state, action) => {
        state.parametroPorId = action.payload;
        state.loadingParametroPorId = false;
      })
      .addCase(fetchParametroId.rejected, (state, action) => {
        state.loadingParametroPorId = false;
        state.errorParametroPorId = action.payload as string;
      });
  },
});

export default parametroPorIdSlice.reducer;
